import { defineStore } from 'pinia'
import Vue from 'vue'
import { isEmpty } from 'lodash'

export const useMdmStore = defineStore('mdm', {
    state: () => {
        return {
            servers: [],
        }
    },
    actions: {

        setServers (servers) {
            Vue.set(this, 'servers', servers)
        },
        getServers () {
            return this.servers
        }

    },
    getters: {}

})
